import EarnPointsTag from './EarnPointsTag';
import LoyaltyBalance from './LoyaltyBalance';
import LoyaltyProgress from './LoyaltyProgress';

export default {
  EarnPointsTag,
  LoyaltyBalance,
  LoyaltyProgress,
};
